<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-building-o" titulo="CADASTRO DE CENTRO DE CUSTO">
        <template #subtitulo>
            <div class="d-flex align-items-center flex-wrap">
                <span class="mr-2">
                    <i class="fa fa-hashtag mr-1 text-info"></i>
                    SEQUÊNCIA: <strong class="text-white">{{registro.SEQUENCIA || 'Novo'}}</strong>
                </span>
                <span v-if="registro.DESCRICAO" class="mx-2">•</span>
                <span v-if="registro.DESCRICAO" class="mr-2">
                    <i class="fa fa-tag mr-1 text-info"></i>
                    {{registro.DESCRICAO}}
                </span>
                
                <div class="ml-3 d-flex align-items-center">
                   <b-badge :variant="registro.STATUS === 'A' ? 'success' : 'secondary'" pill class="px-3 py-1 shadow-sm">
                        {{registro.STATUS === 'A' ? 'ATIVO' : 'INATIVO'}}
                   </b-badge>
                </div>
            </div>
        </template>

        <template #acoes>
            <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="postOrEdit()">
                <i class="fa fa-save mr-1"></i> GRAVAR
            </b-button>

            <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
                <i class="fa fa-arrow-left mr-1"></i> Voltar
            </b-button>
        </template>
    </HeaderPadrao>

    <div class="page-main px-3">
        <b-row>
            <b-col sm="12">
                <b-card no-body class="border-0 shadow-sm mb-4">
                     <div class="card-header bg-white border-bottom-0 pt-3 pb-2">
                        <div class="d-flex align-items-center">
                            <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                                <i class="fa fa-info"></i>
                            </div>
                            <div>
                                <h6 class="mb-0 font-weight-bold">Dados Principais</h6>
                                <small class="text-muted">Informações de identificação do Centro de Custo</small>
                            </div>
                        </div>
                     </div>
                     <b-card-body class="p-4">
                         
                        <b-row class="mb-4 d-flex align-items-center">
                             
                             <b-col sm="3">
                                <label class="modal-label-premium">Código</label>
                                <b-form-input type="text" id="CODIGO" placeholder="Código" v-model="registro.CODIGO" class="rounded-pill shadow-xs"></b-form-input>
                             </b-col>
                             <b-col sm="3">
                                <label class="modal-label-premium">Sequência</label>
                                <b-form-input type="text" id="SEQUENCIA" disabled placeholder="Automático" v-model="registro.SEQUENCIA" class="rounded-pill shadow-xs bg-light"></b-form-input>
                             </b-col>
                             <b-col sm="3">
                                <label class="modal-label-premium d-block mb-2">Status</label>
                                <b-form-checkbox
                                    switch
                                    
                                    id="checkbox-1"
                                    v-model="registro.STATUS"
                                    name="checkbox-1"
                                    value="A"
                                    unchecked-value="I">
                                    <span class="font-weight-bold" :class="registro.STATUS === 'A' ? 'text-success' : 'text-muted'">{{registro.STATUS === 'A' ? 'Ativo' : 'Inativo'}}</span>
                                </b-form-checkbox>
                             </b-col>
                        </b-row>
                        
                        <b-row class="mb-3">
                             <b-col sm="12">
                                <label class="modal-label-premium">Descrição *</label>
                                <b-form-input 
                                    type="text" 
                                    id="edDESCRICAO" 
                                    ref="edDESCRICAO" 
                                    placeholder="Informe a Descrição"
                                    v-model="registro.DESCRICAO"
                                    :state="!!registro.DESCRICAO"
                                    class="rounded-pill shadow-xs"> 
                                </b-form-input>
                             </b-col>
                        </b-row>
                        
                        <b-row>
                            <b-col sm="12">
                                <label class="modal-label-premium">Observação</label>
                                <b-form-textarea 
                                    v-model="registro.OBS" 
                                    placeholder="Observações adicionais..." 
                                    rows="4"
                                    class="shadow-xs border-0 bg-light rounded-lg p-3">
                                </b-form-textarea>
                            </b-col>
                        </b-row>
                     </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
  </div>
</template>

<script>

import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'

export default {
  components: {
    HeaderPadrao
  },
  data () {
    return {
      registro: {
        SEQUENCIA: null,
        CODIGO: null,
        DESCRICAO: null,
        OBS: null,
        STATUS: 'A'
      }
    }
  },
  methods: {
    voltar() { this.$router.push('/cadastros/centrocusto/index') },
    async postOrEdit () {
      if (!this.registro.DESCRICAO) {
        this.$refs.edDESCRICAO.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Descrição')
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)  
        if (!this.registro.SEQUENCIA) {
          const postPayload = { registro: this.registro, login: window.localStorage.getItem('login') }
          const { data } = await this.$http.post(`/api/protected/centrocusto/post`, postPayload)
          if (!data || !data.registro) { Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível cadastrar!' ); return }
          this.registro = {...data.registro[0]}
          this.$store.commit('centrocusto/SET_LIMPAR', null)
          this.$store.commit('centrocusto/SET_REGISTRO_SELECIONADO_ID', this.registro.SEQUENCIA)
          this.$store.commit('centrocusto/SET_SEQUENCIA', this.registro.SEQUENCIA)
          this.$store.commit('centrocusto/SET_PAGINA_ATUAL', 1)
          await this.$store.dispatch('centrocusto/GET_LISTA')
          this.$store.commit('centrocusto/SET_LIMPAR_APENAS_FILTRO', null)
          this.$store.commit('controle/setAguardando', false)
          const msg = await this.$bvModal.msgBoxConfirm('Cadastrado com Sucesso. Continuar Cadastrando?', {
            title: 'Sucesso', size: 'sm', buttonSize: 'xl', okVariant: 'success', okTitle: 'SIM', cancelTitle: 'NÃO', footerClass: 'p-2', hideHeaderClose: false, centered: true, noCloseOnEsc: true, noCloseOnBackdrop: true
          })
          if (msg == true) return
          this.$router.push('/cadastros/centrocusto/index')
        } else {
          const editPayload = { registro: this.registro, login: window.localStorage.getItem('login'), operacao: this.emAlteracao == true ? 'alt' : 'inc' }
          let { data } = await this.$http.post(`/api/protected/centrocusto/edit`, editPayload)
          this.registro = (data?.registro) ?? null
          this.$store.commit('controle/setAguardando', false)
          this.$router.push('/cadastros/centrocusto/index')
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar as informações' )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    limparRegistro () { Tools.resetToNull(this.registro, true) },
    avisos() { if (!this.registro.DESCRICAO) { this.$refs.edDESCRICAO.$refs.input.focus(); Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Descrição'); return true } return false }
  },
  computed: { isDark() {return this.$store.getters['tema/IS_DARK']  } },
  async created () {
    const id = this.$route.params.id ? Number(this.$route.params.id) : null
    try {
      if ( id ) {
        this.emAlteracao = true
        const { data: result } = await this.$http.get(`/api/protected/centrocusto/getById/${id}`)
        if (!Array.isArray(result) || result.length === 0) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Cadastro não localizado.')
          this.$router.replace('/cadastros/centrocusto/index')
          return
        }
        this.registro = { ...result[0] }
      } else {
        this.emAlteracao = false
        await this.limparRegistro()
      }
    } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.replace('/cadastros/centrocusto/index') 
    } finally {
      this.$store.commit('controle/setAguardando', false)  
    }
  },
  mounted (){
    this.$nextTick(() => {
      if (!this.$route.params.id) {
        const c = this.$refs.edDESCRICAO
        if (c?.focus) c.focus()
        else c?.$el?.querySelector('input')?.focus()
      }
    })
  }
}
</script>

<style lang="css" scoped>
.prepend-160 { flex: 0 0 130px; width: 130px; min-width: 130px; }
</style>



// WEBPACK FOOTER //
// src/views/centrocusto/CentroCustoCadastro.vue